import gql from 'graphql-tag';
import { spaceGQLFields } from '../space/index.js';
export const privateMessageGQLQuery = (fields) => gql `
  query privateMessage($input: PrivateMessageInput!) {
    privateMessage(input: $input) {
      ${spaceGQLFields(fields)}
    }
  }
`;
//# sourceMappingURL=privateMessage.gql.js.map